'use client';

import { Box, createSvgIcon, styled, type Theme } from '@mui/material';
import { motion } from 'framer-motion';

import { buttonColors } from '../@types/CTATypes';

import type {
  AllowedColors,
  ButtonColors,
  ImgBoxProps,
  MuiSvgIconProps,
  StyledBoxProps,
} from '../@types/CTATypes';

export const StyledBox = styled( Box )<StyledBoxProps>( {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  typography: 'button',
  borderRadius: 'inherit',
} );

export const MuiSvgIcon: React.FC<MuiSvgIconProps> = ({ svg, ...props }) => {
  const MySvg = createSvgIcon( svg, 'MySvg' );

  return <MySvg {...props} />;
};

export const ImgBox: React.FC<ImgBoxProps> = ({ children, dimension, ...props }) => (
  <StyledBox
    component={motion.div}
    width={dimension}
    height={dimension}
    {...props}
  >
    {children}
  </StyledBox>
);

export const setColor = (theme: Theme, color: AllowedColors): AllowedColors => {
  let myColor: AllowedColors = theme.palette.primary.main;

  if (color !== undefined) {
    myColor = color;

    if (buttonColors.includes( color as ButtonColors )) {
      myColor = theme.palette[color as ButtonColors].main;
    }
  }

  return myColor;
};
